// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__17d55","bounce":"loader_bounce__Lki2D"};